export class INewYearRolloverSteps{
    
}

export class INewYearRollOverRequest{
    stepNumber:number;
    lfcYear:number;
    fyYear:number;
    constructor(stepNumber:number){
        stepNumber = stepNumber;
    }

}
export class INewYearRollOverResponse{
    message:string;
}

export class INewYearRollOverDisplayList{
    newYearRollOverList:Array<INewYearRollOverDisplayElem>;

}
export class INewYearRollOverDisplayElem{
    stepNumber:number;
    stepName:string;
    stepDescription:string;
        constructor (options?: {stepNumber: number; stepName: string;stepDescription:string }) {
        if (options) {
            this.stepNumber = options.stepNumber;
            this.stepName = options.stepName;
            this.stepDescription = options.stepDescription;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/new-year-rollover/new-year-rollover-steps/new-year-rollover-steps.ts
 **/